// extracted by mini-css-extract-plugin
export default {"novel":"index_novel_x40Ab"};